<template>
  <section class="general-login">
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col cols="12" sm="8" lg="4">
          <div class="general-login__container p-5">
            <div>
              <div>
                <div class="text-center">
                  <h3 class="general-login__title">Panel de Administrador</h3>
                  <p>Inicia sesión para continuar</p>
                </div>
                <Form
                  v-model="formDataLogin"
                  class="general-login___form"
                  :config="loginFormConfig"
                  @submit="login()"
                />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Form from "@/components/form";

export default {
  components: {
    Form
  },
  data() {
    return {
      formType: "login",
      formDataLogin: {},
      recoveryForm: {},
      recoveryFormConfig: {
        fields: [
          {
            name: "email",
            text: "E-mail",
            type: "email",
            rules: {
              required: true,
              email: true
            }
          }
        ],
        submitText: "Enviar",
        submitClasses: "button text-uppercase mt-3 "
      },
      loginFormConfig: {
        fields: [
          {
            label: "E-mail",
            name: "email",
            text: "E-mail",
            type: "email",
            rules: {
              required: true,
              email: true
            }
          },
          {
            label: "Contraseña",
            name: "password",
            text: "Contraseña",
            type: "password",
            rules: {
              min: 3,
              required: true
            }
          }
        ],
        floatingLabels: true,
        submitText: "Iniciar sesion",
        submitClasses: "button text-uppercase mt-3 "
      }
    };
  },
  methods: {
    login() {
      const { email, password } = this.formDataLogin;
      this.$store.dispatch("login", { email, password });
    }
  }
};
</script>

<style>
.general-login {
  width: 100vw;
  height: 90vh;
  background-color: #f5f5f59e;
  display: flex;
  align-items: center;
}

.general-login__title {
  font-size: 2.5rem;
}

.general-login__container {
  box-shadow: 0px 0px 15px -4px rgba(0, 0, 0, 0.75);
  background-color: white;
}

.general-login___form {
  padding: 2rem 4rem;
}

.general-login___form input {
  border: inherit;
  border-bottom: 1px solid #6c757d;
  border-radius: inherit;
  padding: 1rem 0;
}

.general-login___form button,
.general-login__btn {
  background-color: #b84942;
  border: #b84942;
  color: white;
}

.general-login___form button:hover,
.general-login___form button:active,
.general-login___form button:focus,
.general-login__btn:hover,
.general-login__btn:active,
.general-login__btn:focus {
  background-color: #792e29;
  border: #792e29;
}

.recovery-password {
  cursor: pointer;
  transition: all ease-in 0.2s;
}

.recovery-password:hover {
  color: #792e29;
}
</style>
